import type { FeathersList, Vehicle } from '../types'
import { store } from '../store'
import apiClient from './apiClient'

export const vehicleApi = apiClient.injectEndpoints({
  endpoints: (builder) => ({
    getVehicles: builder.query<FeathersList<Vehicle>, void>({
      query: () => {
        const ownerId = store.getState()?.auth?.user?._id ?? null
        return {
          url: `/vehicles?$limit=1000&ownerId=${ownerId}`,
          method: 'GET',
        }
      },
      providesTags: ['Vehicle'],
    }),
    createVehicle: builder.mutation<Vehicle, Record<string, unknown>>({
      query: (body) => ({ url: '/vehicles', method: 'POST', body }),
      invalidatesTags: ['Vehicle'],
    }),
    patchVehicle: builder.mutation<Vehicle, { _id: string } & Record<string, unknown>>({
      query: ({ _id, ...rest }) => ({
        url: `/vehicles/${_id}`,
        method: 'PATCH',
        body: rest,
      }),
      invalidatesTags: ['Vehicle'],
    }),
  }),
  overrideExisting: true,
})

export const {
  useGetVehiclesQuery,
  useCreateVehicleMutation,
  usePatchVehicleMutation,
} = vehicleApi
